import { store } from '@project/store';

export const onDeleteLayers = (id: string) => {
  const map = store.map.mapProperties.map;
  const layers = map
    .getLayers()
    .getArray()
    .filter((layer) => layer.get(id));
  layers?.forEach((layer) => {
    map.removeLayer(layer);
  });

  const overlays = map
    .getOverlays()
    .getArray()
    .filter((overlay) => overlay.get(id));
  overlays?.forEach((overlay) => {
    map.removeOverlay(overlay);
  });

  const interactions = map
    .getInteractions()
    .getArray()
    .filter((interaction) => interaction.get(id));
  interactions?.forEach((interaction) => {
    map.removeInteraction(interaction);
  });
};
